import React, { useRef } from 'react';
import { SmartListContextMenu } from 'shared/components/connected/smart-list-context-menu';
import { SmartListSideMenuItem } from 'shared/components/ui/smart-list-side-menu-item';
import { SmartListFormDialog } from 'shared/dialogs/smart-list-form-dialog';
import { useOpenMenu } from 'shared/hooks/use-open-menu';
import { SmartList } from 'shared/types/smart-list';

type SmartListSideNavigationItemProps = {
  smartList: SmartList;
  children?: React.ReactNode;
  hasDnd?: boolean;
};

export const SmartListSideNavigationItem: React.FC<
  SmartListSideNavigationItemProps
> = ({ smartList, children, hasDnd }) => {
  const itemRef = useRef<HTMLDivElement>(null);
  const { menuOpen, openContextMenu, closeMenu } = useOpenMenu();
  const {
    menuOpen: editOpen,
    openMenu: openEdit,
    closeMenu: closeEdit,
  } = useOpenMenu();

  return (
    <>
      <SmartListSideMenuItem
        ref={itemRef}
        smartList={smartList}
        hasDnd={hasDnd}
        onContextMenu={smartList.frozenAt ? undefined : openContextMenu}
      >
        {children}
      </SmartListSideMenuItem>

      <SmartListContextMenu
        smartList={smartList}
        referenceElement={itemRef}
        onClose={closeMenu}
        onEdit={openEdit}
        open={menuOpen}
      />

      {editOpen && (
        <SmartListFormDialog open onClose={closeEdit} smartList={smartList} />
      )}
    </>
  );
};
